/**
 * Pet onboarding CTA — flow dla niezalogowanych gości.
 *
 * 1. Submit formularza [data-hn-pet-cta-form] → preventDefault.
 * 2. Dane zapisujemy w localStorage `hn_pending_pet`.
 * 3. Otwieramy modal [data-hn-pet-cta-modal] z propozycją „załóż konto / zaloguj się / pomiń".
 * 4. „Pomiń" → zamykamy modal i kierujemy do sklepu (bez konta).
 *
 * Bez tego modułu form robił default GET na bieżący URL z polami jako query params,
 * a pole `name=` (zarezerwowane query var WP) prowadziło do 404.
 */

const STORAGE_KEY = 'hn_pending_pet';
const SHOP_URL = '/sklep/';

function collect(form) {
    const fd = new FormData(form);
    const allergies = fd.getAll('allergies[]').filter(Boolean);
    return {
        name: (fd.get('pet_name') || '').toString().trim(),
        species: (fd.get('species') || 'dog').toString(),
        age_years: parseFloat(fd.get('age_years')) || null,
        allergies,
        captured_at: new Date().toISOString(),
    };
}

function fillSummary(modal, data) {
    const summaryEl = modal.querySelector('[data-hn-pet-cta-modal-summary]');
    if (!summaryEl) return;
    const parts = [];
    if (data.name) parts.push('<strong>' + escapeHtml(data.name) + '</strong>');
    if (data.age_years) parts.push(data.age_years + ' lat');
    if (data.allergies && data.allergies.length) {
        parts.push('alergie: ' + data.allergies.map(escapeHtml).join(', '));
    }
    summaryEl.innerHTML = parts.length ? '<p>' + parts.join(' · ') + '</p>' : '';
}

function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
}

function openModal(modal) {
    if (typeof modal.showModal === 'function') {
        modal.showModal();
    } else {
        modal.setAttribute('open', '');
    }
}

function closeModal(modal) {
    if (typeof modal.close === 'function' && modal.open) {
        modal.close();
    } else {
        modal.removeAttribute('open');
    }
}

export function initPetOnboarding() {
    const form = document.querySelector('[data-hn-pet-cta-form]');
    if (!form) {
        return;
    }
    const modal = document.querySelector('[data-hn-pet-cta-modal]');

    form.addEventListener('submit', (event) => {
        event.preventDefault();

        const data = collect(form);
        if (!data.name) {
            const input = form.querySelector('input[name="pet_name"]');
            if (input) input.focus();
            return;
        }

        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        } catch (e) { /* private mode / disabled storage — kontynuuj */ }

        if (modal) {
            fillSummary(modal, data);
            openModal(modal);
        }
    });

    if (!modal) {
        return;
    }

    // Zamknięcie modala — krzyżyk, backdrop, Escape.
    modal.addEventListener('click', (event) => {
        if (event.target === modal) {
            closeModal(modal);
        }
        const closeBtn = event.target.closest('[data-hn-pet-cta-modal-close]');
        if (closeBtn) {
            closeModal(modal);
        }
        const skipBtn = event.target.closest('[data-hn-pet-cta-skip]');
        if (skipBtn) {
            closeModal(modal);
            // Pomiń konto — kieruj do sklepu, przekazując alergeny i wiek psa w query.
            // Backend (inc/pet-personalization.php → woocommerce_product_query) wyklucza
            // produkty zawierające te alergeny.
            try {
                const stored = localStorage.getItem(STORAGE_KEY);
                if (stored) {
                    const data = JSON.parse(stored);
                    const params = new URLSearchParams();
                    if (Array.isArray(data.allergies) && data.allergies.length) {
                        params.set('hn_alergeny', data.allergies.join(','));
                    }
                    if (data.age_years) {
                        params.set('hn_pet_age', String(data.age_years));
                    }
                    if (data.name) {
                        params.set('hn_pet_name', data.name);
                    }
                    const qs = params.toString();
                    window.location.href = SHOP_URL + (qs ? '?' + qs : '');
                    return;
                }
            } catch (e) { /* localStorage padło — kieruj do sklepu bez query */ }
            window.location.href = SHOP_URL;
        }
    });
}
